import PropTypes from 'prop-types';
import React from 'react';

import useTranslation from '../../hooks/use_translation';
import GroupLink from './group_link';
import MarkerIcon from './svgs/icons/marker-icon';

const BiomarkerAmount = ({
	className,
	color = 'light',
	count,
	flush = false,
	groups,
	product_id,
	size = 'sm',
	...props
}) => {
	const { t } = useTranslation('component_biomarker_amount');

	const sizeList = {
		lg: 'lead',
		md: 'base',
		sm: 'small',
		xs: 'list-subtitle',
		xxs: 'xxs',
	};

	const colors = {
		dark: 'text-white border-light',
		light: 'text-dark ',
	};

	return (
		<GroupLink
			className={`${className} text-decoration-none d-inline-flex align-items-center`}
			groups={groups}
			page="tester"
			product_id={product_id}
			{...props}
		>
			<div
				className={`${sizeList[size]} ${flush == true ? '' : 'product-badge'} ${colors[color]}`}
			>
				<MarkerIcon /> {count} {count > 1 ? t('t1') : t('t2')}
			</div>
		</GroupLink>
	);
};

BiomarkerAmount.propTypes = {
	className: PropTypes.string,
	color: PropTypes.string,
	count: PropTypes.number,
	flush: PropTypes.bool,
	groups: PropTypes.array,
	product_id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
	size: PropTypes.string,
	slug: PropTypes.string,
};

export default BiomarkerAmount;
